import React, { useState } from 'react';
import '@fontsource/source-sans-pro';
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import HeaderIcon from '@mui/icons-material/DirectionsBus';
import MainMenuItem from './basics/MainMenuItem';
import COLORS from './styles/Colors';

const StyledDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    backgroundColor: COLORS.ZINC300,
  },
}));
const StyledHeaderBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontFamily: '"Source Sans Pro", "Roboto", Verdana, sans-serif',
  fontSize: 26,
  fontWeight: 'bold',
  backgroundColor: COLORS.NEUTRAL900,
  color: COLORS.ZINC200,
  padding: '1rem',
  boxShadow: 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
}));
const StyledHeaderIcon = styled(HeaderIcon)(() => ({
  fontSize: 36,
  marginRight: '0.75rem',
  color: COLORS.GREEN400,
}));
const StyledDivider = styled(Divider)(() => ({
  borderWidth: 2,
  borderColor: 'rgb(144, 144, 144)',
  marginTop: '0.75rem',
  marginBottom: '0.75rem',
}));

const MainMenu = ({
  location,
  logOut,
  secondary,
}) => {
  const [mainMenuOpen, setMainMenuOpen] = useState(false);

  const toggleMainMenu = (toggleValue) => (e) => {
    if (e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Shift')) {
      return;
    }
    setMainMenuOpen(toggleValue);
  };

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="open drawer"
        onClick={toggleMainMenu(true)}
        sx={{ ml: 1, mr: 2 }}
      >
        <MenuIcon />
      </IconButton>
      <StyledDrawer
        anchor="left"
        open={mainMenuOpen}
        onClose={toggleMainMenu(false)}
      >
        <Box sx={{ width: 280 }} role="presentation">
          <StyledHeaderBox>
            <StyledHeaderIcon />
            SCTP Caebes
          </StyledHeaderBox>
          <List sx={{ padding: 0, marginTop: '0.75rem' }}>
            <MainMenuItem pageItem="recorridos" location={location} />
            <MainMenuItem pageItem="historial" location={location} />
            {secondary === 'false' && (
              <>
                <StyledDivider variant="middle" component="li" />
                <MainMenuItem pageItem="reporte" location={location} />
                <MainMenuItem pageItem="atrasos" location={location} />
                <MainMenuItem pageItem="semanal" location={location} />
                <MainMenuItem pageItem="operadores" location={location} />
                <MainMenuItem pageItem="tiempos" location={location} />
                <MainMenuItem pageItem="reportezonas" location={location} />
                <MainMenuItem pageItem="frecuencias" location={location} />
                <MainMenuItem pageItem="checadores" location={location} />
                <MainMenuItem pageItem="salidas" location={location} />
                <MainMenuItem pageItem="logincheckers" location={location} />
              </>
            )}
            <StyledDivider variant="middle" component="li" />
            <MainMenuItem pageItem="logout" location={location} sessionout={logOut} />
          </List>
        </Box>
      </StyledDrawer>
    </>
  );
};

export default MainMenu;
